// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__rA_IE","footer":"ChangeClinic_footer__16FSS"};